import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { ParticipacionesRelevantesDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class ParticipacionesRelevantesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getParticipacionesRelevantesService(): Observable<BodyListResponse<ParticipacionesRelevantesDTO>> {
    return this.http.get<BodyListResponse<ParticipacionesRelevantesDTO>>(API_URL + '/api/v1/participacionesRelevantes/todos');
  }

  guardarParticipacionesRelevantesService(participacionesRelevantesDTO: ParticipacionesRelevantesDTO): Observable<ParticipacionesRelevantesDTO> {
    return this.http.post<ParticipacionesRelevantesDTO>(API_URL + '/api/v1/participacionesRelevantes', participacionesRelevantesDTO);
  }

  getParticipacionesRelevantesPorCodigoParticipacionesRelevantesService(codigoParticipacionesRelevantes: string): Observable<BodyResponse<ParticipacionesRelevantesDTO>> {
    return this.http.get<BodyResponse<ParticipacionesRelevantesDTO>>(API_URL + '/api/v1/participacionesRelevantes/' + codigoParticipacionesRelevantes);
  }


  getParticipacionesRelevantesPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<ParticipacionesRelevantesDTO>> {
    return this.http.get<BodyListResponse<ParticipacionesRelevantesDTO>>(API_URL + '/api/v1/participacionesRelevantes/persona/' + codigoPersona);
  }
}
